export const COMMAND_START = 'START';
export const COMMAND_PAUSE = 'PAUSE';
